import cn from 'classnames';
import type React from 'react';
import { UploadArrow, UploadVideoCancel } from '@shared/assets';
import { IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  value?: string;
  error?: boolean;
  uploaded?: boolean;
}

export const VideoUploadButton: React.FC<Props> = ({
  value,
  error,
  uploaded = false,
  ...props
}) => {
  const headingText = value ? (uploaded ? `Загруженное видео` : `Загружаемое видео:`) : '';
  return (
    <div className={cn(st.video, error && !value && st.error)} {...props}>
      <div className={st.wrapper}>
        <h3 className={cn(st.video__heading)}>{headingText}</h3>
        {value && <p className={st.video__title}>{value}</p>}
        {!value ? (
          <div className={cn(st.video__icon, st.large)}>{<UploadArrow />}</div>
        ) : (
          <div className={st.video__cancel}>
            <IconButton variant="dark" size="medium">
              <UploadVideoCancel />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};
